"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const logger_models_1 = require("./logger.models");
const noop = () => undefined;
class Logger {
    constructor(className, enabled, logLevel, style) {
        this._logPrefix = "%c<<MNG_Plugins>>";
        this._className = "General";
        this._enabled = true;
        this._logLevel = logger_models_1.LogLevel.Debug;
        this._style = "";
        // console.log("Logger.CTOR", className, enabled, logLevel, style);
        this._className = className;
        this._enabled = enabled;
        this._logLevel = logLevel;
        this._style = style;
    }
    setLogPrefix(val) {
        // console.log('Logger.setEnabled == ', clsName, val);
        this._logPrefix = val;
    }
    setEnabled(val) {
        let clsName = this._className;
        //console.log('Logger.setEnabled == ', clsName, val);
        this._enabled = val;
    }
    setLogLevel(level) {
        //console.log('Logger.setLogLevel == ', this._className, level);
        this._logLevel = level;
    }
    format() {
        return this._logPrefix + "[" + this._className + "] ";
    }
    getStyle(logLevel) {
        let style;
        let bg = "none";
        if (this._style) {
            //console.log("getStyle | has Style");
            style = this._style;
            bg = logger_models_1.LOG_LEVEL_STYLE[logLevel].bg;
        }
        else {
            //console.log("getStyle | NO Style");
            style = logger_models_1.LOG_LEVEL_STYLE[logLevel].color;
            bg = logger_models_1.LOG_LEVEL_STYLE[logLevel].bg;
        }
        //console.log("getStyle | ", "bg", bg, "style ", style);
        return `color: ${style}; background-color: ${bg}; padding: 2px; border-radius: 3px;`;
        //return ["color:" + style + ";font-weight:bold;"];
        // return ["color:" + style + ";font-weight:bold;background:" + bg + ";"];
        // return ["color:#004000;font-weight:bold;background:rgba(51, 170, 51, .1)"];
    }
    get debug() {
        if (this.isEnabled(logger_models_1.LogLevel.Debug)) {
            return console.debug.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Debug));
        }
        else {
            return noop;
        }
    }
    get info() {
        if (this.isEnabled(logger_models_1.LogLevel.Info)) {
            return console.info.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Info));
        }
        else {
            return noop;
        }
    }
    get warn() {
        if (this.isEnabled(logger_models_1.LogLevel.Warn)) {
            return console.warn.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Warn));
        }
        else {
            return noop;
        }
    }
    get error() {
        if (this.isEnabled(logger_models_1.LogLevel.Error)) {
            return console.error.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Error));
        }
        else {
            return noop;
        }
    }
    get fatal() {
        if (this.isEnabled(logger_models_1.LogLevel.Fatal)) {
            return console.error.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Fatal));
        }
        else {
            return noop;
        }
    }
    get trace() {
        if (this.isEnabled(logger_models_1.LogLevel.Trace)) {
            //console.log("this.format()", this.format());
            //console.log("this.getStyle(LogLevel.Trace)", this.getStyle(LogLevel.Trace));
            return console.debug.bind(console, this.format(), this.getStyle(logger_models_1.LogLevel.Trace));
        }
        else {
            return noop;
        }
    }
    /* PRIVATE */
    /*TODO: Create function that creates the preface and also handles console colorize depending on browser (IE does not support colors, so style is printed) */
    isEnabled(logLevel) {
        //if this_logLevel == info which is
        //console.log(`isEnabled | logLevel: ${logLevel} | this._logLevel: ${this._logLevel} `);
        //console.log("isEnabled", "logLevel", logLevel, "this._logLevel", this._logLevel);
        if (logLevel >= this._logLevel && this._enabled) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.Logger = Logger;
